setTimeout(function(){
    buyItNowButtonsCollection = document.getElementsByClassName('shopify-payment-button__button');
    if(buyItNowButtonsCollection.length) {
		buyItNowButton = buyItNowButtonsCollection[0];
		buyItNowButton.textContent = 'לרכישה מהירה';
        document.querySelector('.shopify-payment-button').style.display = 'block'
    }
}, 1000);

setTimeout(function(){
    buyItNowButtonsCollection = document.getElementsByClassName('shopify-payment-button__button--unbranded');
    if(buyItNowButtonsCollection.length) {
		buyItNowButton = buyItNowButtonsCollection[0];
		buyItNowButton.textContent = 'לרכישה מהירה';
    }
}, 2000);

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const widgets = document.querySelectorAll('.chatpoint-widget');
  
    widgets.forEach((widget) => {
      if (!widget.shadowRoot) return;
  
      // Avoid injecting the style multiple times
      if (widget.shadowRoot.querySelector('style[data-font-fix]')) return;
  
      const style = document.createElement('style');
      style.setAttribute('data-font-fix', 'true');
      style.textContent = `
        * {
          font-family: "Polin-Regular", sans-serif !important;
        }
      `;
      widget.shadowRoot.appendChild(style);
    });
  
    // Optional: clear interval if all widgets are loaded
    if (widgets.length > 0 && [...widgets].every(w => w.shadowRoot)) {
      clearInterval(interval);
    }
  }, 300);
  
  const checkout_button = document.querySelector('.btn[name="checkout"]')
  const checkbox = document.getElementById("accept-terms");
  
  if (checkout_button) {
    const errorMessage = document.createElement("div");
    errorMessage.textContent = "יש לאשר את תנאי השימוש לפני המשך";
    errorMessage.style.color = "red";
    errorMessage.style.fontSize = "1.4rem";
    errorMessage.style.lineHeight = "1";
    errorMessage.style.display = "none";

    // Insert the error message after the checkbox container
    const checkboxContainer = checkbox.closest("div");
    checkboxContainer.appendChild(errorMessage);
    
    checkout_button.addEventListener('click', function(e) {
      e.preventDefault()
      if (!checkbox.checked) {
        errorMessage.style.display = "block";
      } else {
        errorMessage.style.display = "none";
        window.location.href = '/checkout'
      }
    })

    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        errorMessage.style.display = "none";
      }
    });
  }
});